module.exports = __webpack_public_path__ + "img/dm.383e70c1.jpg";